export default __webpack_public_path__ + "static/media/Dickcatz-OfficialSelection.fc57e2c9.svg";